<section class="gw-chkout-payment-processing">
  <div class="gw-chkout-payment-processing__top-bar"></div>
  <div class="gw-chkout-payment-processing__content">
    <div class="gw-chkout-payment-processing__spinner">
      <mat-spinner diameter="130"></mat-spinner>
    </div>
    <div class="gw-chkout-payment-processing__title">
      <h2>Thank you for your patience!</h2>
    </div>
    <div class="gw-chkout-payment-processing__message">
      <p>We’re finalizing your payment.<br>
        This might take a few extra seconds.<br>
        Please don’t refresh or close the page.
      </p>
    </div>
  </div>
</section>
